import {
  Typography,
  Grid,
} from "@material-ui/core";
import React from "react";
import { LinkModel } from "../../domain/LinkModel";
import { ListItem } from "../section/ListItem";


export const ItemsList: React.FC<{ items: LinkModel[] }> = ({ items }) => {

  let lastCategoryTitle: string = "";

  return (
    <Grid container spacing={10} style={{ padding: 50 }}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {lastCategoryTitle !== item.categoryTitle && (
            <>
              <Typography component="div" id = {item.anchor}/>            
              <Grid item xs={12}>
                <Typography variant="h3" component="div">
                  {lastCategoryTitle = item.categoryTitle}
                </Typography>
              </Grid>
            </>
          )}

          <ListItem
            title={item.title}
            description={item.description}
            linkUrl={item.linkUrl}></ListItem>

        </React.Fragment>
      ))}
    </Grid>
  );
};
